import dompurify from 'isomorphic-dompurify';
import type { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

interface HtmlContentRendererProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'dangerouslySetInnerHTML'> {
  html: string;
}

export const HtmlContentRenderer = ({
  html,
  className,
  style,
  ...rest
}: HtmlContentRendererProps) => (
  <div
    className={twMerge(
      'max-w-none [&_p]:mb-3 [&_ol]:mb-4 [&_ol]:pl-5 [&_ol]:list-decimal [&_li]:mb-2 [&_.c4]:font-semibold [&_.c4]:text-base [&_.c1]:text-sm [&_.c1]:leading-relaxed',
      className,
    )}
    style={{
      fontSize: '13px',
      lineHeight: '1.6',
      color: '#000',
      ...style,
    }}
    dangerouslySetInnerHTML={{ __html: dompurify.sanitize(html) }}
    {...rest}
  />
);
